import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import ClientsPage from "@/pages/ClientsPage";
import ClientDetailPage from "@/pages/ClientDetailPage";
import TasksPage from "@/pages/TasksPage";
import DocumentsPage from "@/pages/DocumentsPage";
import NotificationsPage from "@/pages/NotificationsPage";
import ActivityPage from "@/pages/ActivityPage";
import UsersPage from "@/pages/UsersPage";
import SettingsPage from "@/pages/SettingsPage";
import LoginHistoryPage from "@/pages/LoginHistoryPage";
import InvoicesPage from "@/pages/InvoicesPage";
import RecurringTasksPage from "@/pages/RecurringTasksPage";
import LandingPage from "@/pages/LandingPage";
import HelpPage from "@/pages/HelpPage";

import SystemDashboardPage from "@/pages/SystemDashboardPage";

export default function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/landing" element={<Navigate to="/" replace />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/auth/reset-password" element={<ForgotPasswordPage />} />
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/clients" element={<ClientsPage />} />
                <Route
                  path="/clients/:clientId"
                  element={<ClientDetailPage />}
                />
                <Route path="/tasks" element={<TasksPage />} />
                <Route
                  path="/tasks/recurring"
                  element={<RecurringTasksPage />}
                />
                <Route path="/invoices" element={<InvoicesPage />} />
                <Route path="/documents" element={<DocumentsPage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/activity" element={<ActivityPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/settings/login-history" element={<LoginHistoryPage />} />
                <Route path="/help" element={<HelpPage />} />
                
                <Route path="/system" element={<Navigate to="/system/organizations" replace />} />
                <Route path="/system/organizations" element={<SystemDashboardPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}
